if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        let activitySwitch = 'false'
        activitySwitch = document.querySelector('#activity-switch')?.innerHTML || 'false';
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        let currentID = this.form.querySelector('.product-variant-id').value

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        try {
          console.log('activitySwitch', activitySwitch);

          // let xProductList = ['43557890261026', '43204308729890', '43673986301986', '43791191113762', '43791191146530', '43791191179298', '43552086130722', '43552106348578', '43673973293090', '43791215886370', '43791215919138', '43791215951906']
          let xProductList = ['43557890261026','43972592730146','43552086130722','43552106348578']
          // let hProductList = ['43784388608034','43784388640802','43519835439138','43519835471906','43558011666466','43558011699234','43784477540386','43784477573154','43520265846818','43520265879586','43551549554722','43551549587490']
          let hProductList = ['43519835439138','43519835471906','43784477573154','43520265879586','43551549587490']

          if (activitySwitch === 'true' && (xProductList.includes(currentID) || hProductList.includes(currentID))) {
            // ================= 1. 先添加赠品 =================
            // const GIFT_VARIANT_ID = '43173642567714'; // 替换为实际赠品ID
            const GIFT_VARIANT_ID = '43956781219874'; // 替换为实际赠品ID

            await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{ id: GIFT_VARIANT_ID, quantity: 1 }]
              })
            });
          }

          // ================= 2. 再加购主产品 =================
          const mainProductResponse = await fetch(`${routes.cart_add_url}`, config);
          const response = await mainProductResponse.json();

          // 错误处理（库存不足等）
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            return;
          }

          // ================= 3. 更新UI =================
          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => this.cart.renderContents(response));
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }

        } catch (e) {
          console.error('error:', e);
          this.error = true;
        } finally {
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading__spinner').classList.add('hidden');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          if (this.cart?.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
        }
      }

      // async onSubmitHandler(evt) {
      //   console.log('submit')
      //   evt.preventDefault();
      //   if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      //   this.handleErrorMessage();

      //   this.submitButton.setAttribute('aria-disabled', true);
      //   this.submitButton.classList.add('loading');
      //   this.querySelector('.loading__spinner').classList.remove('hidden');

      //   const config = fetchConfig('javascript');
      //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
      //   delete config.headers['Content-Type'];

      //   const formData = new FormData(this.form);
      //   if (this.cart) {
      //     formData.append(
      //       'sections',
      //       this.cart.getSectionsToRender().map((section) => section.id)
      //     );
      //     formData.append('sections_url', window.location.pathname);
      //     this.cart.setActiveElement(document.activeElement);
      //   }
      //   config.body = formData;

      //   // 如果点击的是补充产品，则执行下面逻辑
      //   let recommendationBox = this.form.closest('product-recommendations')
      //   if(false){
      //     // 获取当前变体ID
      //     let currentProductID = new URLSearchParams(window.location.search).get('variant');
      //     if(!currentProductID){
      //       const button = document.querySelector('.new_buttonsss');
      //       if (button) {
      //         const parent = button.closest('form');
      //         if (parent) {
      //           const input = parent.querySelector('input[name="id"]');
      //           if (input) {
      //             currentProductID = input.value
      //           }
      //         }
      //       }
      //     }
      //     // 把当前变体ID和购物车做对比
      //     let hasProduct = false
      //     await fetch(window.Shopify.routes.root + 'cart.js', {
      //       method: 'GET',
      //       headers: {
      //         'Content-Type': 'application/json'
      //       },
      //     })
      //     .then(response => response.json())
      //     .then(res => {
      //       for(let i=0; i<res.items.length;i++){
      //         if(currentProductID == res.items[i].id){
      //           hasProduct = true
      //         }
      //       }
      //     })
      //     // 把当前变体ID和购物车做对比，如果购物车内没有当前产品，则往购物车内添加此产品
      //     if(!hasProduct){
      //       let mainProduct = {
      //         items: [{
      //           'id': currentProductID,
      //           'quantity': 1
      //         }]
      //       };
      //       await fetch(window.Shopify.routes.root + 'cart/add.js', {
      //         method: 'POST',
      //         headers: {
      //           'Content-Type': 'application/json'
      //         },
      //         body: JSON.stringify(mainProduct)
      //       })
      //       .then(response => response.json())
      //       .then(function(data) {
      //           if (data.status === 422) {
      //           } else {
      //             console.log('Success')
      //           }
      //       })
      //       .catch((error) => {
      //         console.error('Error:', error);
      //       });
      //     }
      //   }

      //   fetch(`${routes.cart_add_url}`, config)
      //     .then((response) => response.json())
      //     .then((response) => {
      //       if (response.status) {
      //         publish(PUB_SUB_EVENTS.cartError, {
      //           source: 'product-form',
      //           productVariantId: formData.get('id'),
      //           errors: response.errors || response.description,
      //           message: response.message,
      //         });
      //         this.handleErrorMessage(response.description);

      //         const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      //         if (!soldOutMessage) return;
      //         this.submitButton.setAttribute('aria-disabled', true);
      //         this.submitButtonText.classList.add('hidden');
      //         soldOutMessage.classList.remove('hidden');
      //         this.error = true;
      //         return;
      //       } else if (!this.cart) {
      //         window.location = window.routes.cart_url;
      //         return;
      //       }

      //       if (!this.error)
      //         publish(PUB_SUB_EVENTS.cartUpdate, {
      //           source: 'product-form',
      //           productVariantId: formData.get('id'),
      //           cartData: response,
      //         });
      //       this.error = false;
      //       const quickAddModal = this.closest('quick-add-modal');
      //       if (quickAddModal) {
      //         document.body.addEventListener(
      //           'modalClosed',
      //           () => {
      //             setTimeout(() => {
      //               this.cart.renderContents(response);
      //             });
      //           },
      //           { once: true }
      //         );
      //         quickAddModal.hide(true);
      //       } else {
      //         this.cart.renderContents(response);
      //       }
      //     })
      //     .catch((e) => {
      //       console.error(e);
      //     })
      //     .finally(() => {
      //       this.submitButton.classList.remove('loading');
      //       if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      //       if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      //       this.querySelector('.loading__spinner').classList.add('hidden');
      //     });
      // }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
